import { useEffect } from 'react';
import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';

const $suppressorCount = atom(0);

/**
 * Hide the agent launcher while this component is mounted and `isSuppressed`.
 *
 * Counted like `useSuppressSidebar`, so two suppressors cannot un-hide the
 * launcher when the first unmounts. Pages declare their own need — a page that
 * carries its own agent composer suppresses the global one — rather than the
 * launcher route-matching and re-deriving which screen is showing.
 */
export function useSuppressAgentLauncher(isSuppressed: boolean): void {
  useEffect(() => {
    if (!isSuppressed) {
      return;
    }
    $suppressorCount.set($suppressorCount.get() + 1);
    return () => {
      $suppressorCount.set(Math.max($suppressorCount.get() - 1, 0));
    };
  }, [isSuppressed]);
}

export function useIsAgentLauncherSuppressed(): boolean {
  return useStore($suppressorCount) > 0;
}
